/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_9_QInputs */

const en_mk_pricing_faq_9_q = /** @type {(inputs: Mk_Pricing_Faq_9_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can we run it on our own servers?`)
};

const id_mk_pricing_faq_9_q = /** @type {(inputs: Mk_Pricing_Faq_9_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisakah kami memasangnya di server sendiri?`)
};

/**
* | output |
* | --- |
* | "Can we run it on our own servers?" |
*
* @param {Mk_Pricing_Faq_9_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_9_q = /** @type {((inputs?: Mk_Pricing_Faq_9_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_9_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_9_q(inputs)
	return en_mk_pricing_faq_9_q(inputs)
});